<template>
    <form v-if="form" @submit.prevent="submitForm" @input="onFormChange">
        <div class="grid grid-cols-2 gap-4 mb-2">
            <div class="col-span-2">
                <my-input
                    v-model="form.name"
                    name="name"
                    :error="form.errors.get('name')"
                    :autofucos="true"
                    label="Service Name"
                    placeholder="e.g. Logo Design"
                />
            </div>
            <my-input v-model="form.cost" name="cost" :error="form.errors.get('cost')" label="Cost" placeholder="e.g. 240" />
            <div class="flex flex-col w-full">
                <label class="font-bold mb-1">Currency</label>
                <div class="relative">
                    <select
                        v-model="form.currency_id"
                        name="currency"
                        class="block appearance-none w-full bg-gray-200 border border-gray-200 py-3 px-4 pr-8 rounded leading-normal focus:outline-none focus:bg-white focus:border-gray-500"
                        :class="{
                            'text-gray-500': form.currency_id === null,
                            'text-gray-700': form.currency_id !== null,
                            'border-red-500': form.errors.get('currency_id')
                        }"
                    >
                        <option :value="null" disabled selected>Currency</option>
                        <option v-for="currency in currencies" :key="currency.id" :value="currency.id">{{
                            currency.name
                        }}</option>
                    </select>
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                        </svg>
                    </div>
                </div>
                <span v-if="form.errors.get('currency_id')" class="mt-1 text-xs text-italic mt-1 text-red-500">
                    {{ form.errors.get('currency_id') }}
                </span>
            </div>
            <div class="col-span-2">
                <rich-editor v-model="form.description" label="Service Description" placeholder="Describe your service here..." />
            </div>
        </div>
    </form>
</template>

<script>
import Form from '../../forms/form';

export default {
    props: {
        updateRec: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            fields: ['name', 'description', 'cost', 'currency_id'],
            currencies: [],
            selectedCurrency: null,
            form: null
        };
    },

    mounted() {
        this.initForm();
        this.fetchCurrencies();
    },

    methods: {
        initForm() {
            let formData = {};

            if (this.updateRec) {
                this.fields.forEach(field => (formData[field] = this.updateRec[field]));
            } else {
                this.fields.forEach(field => (formData[field] = null));
            }

            this.form = new Form(formData);
            this.form.no_expiration = false;
        },

        fetchCurrencies() {
            axios.get(`/api/currencies`).then(response => {
                this.currencies = response.data.data;
            });
        },

        submit() {
            let uri = this.updateRec ? `/api/user/services/${this.updateRec.slug}` : `/api/user/services`;

            return new Promise((resolve, reject) => {
                this.form
                    .post(uri)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        onFormChange(event) {
            this.form.errors.clear(event.target.name);
        }
    }
};
</script>
